import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { getCryptoWallets } from '../cryptoWalletsEndpoints'
import type { GetCryptoWalletsParams } from '../../types/cryptoWalletTypes'

export function useCryptoWalletsQuery(filters: MaybeRefOrGetter<Partial<GetCryptoWalletsParams>>) {
  return useQuery({
    queryKey: () => cryptoWalletsKeys.list(toValue(filters)),
    queryFn: () =>
      getCryptoWallets({
        page: 1,
        limit: 10,
        ...toValue(filters),
      }),
  })
}
